import { render, staticRenderFns } from "./Riprogramma.vue?vue&type=template&id=34866c57&"
import script from "./Riprogramma.vue?vue&type=script&lang=js&"
export * from "./Riprogramma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports